import request from '@/utils/request'


export function userPuserAuthentication(name, birthday, picture, qualifications, position, title, city, cityMarket, credential, introduce, securityField, greatField, honor, project, mainCourse, workHistory, industryType, quotation, phone) {
    return request({
        url: `api/puserAuthentication/user/puserAuthentication`,
        // url: "api/meeting/searchMeeting",
        method: 'post',
        // data
        data: {
            'name': name,
            'birthday': birthday,
            'picture': picture,
            'qualifications': qualifications,
            'position': position,
            'title': title,
            'city': city,
            'cityMarket': cityMarket,
            'credential': credential,
            'introduce': introduce,
            'honor': honor,
            'project': project,
            'mainCourse': mainCourse,
            'industryType': industryType,
            'securityField': securityField,
            'greatField': greatField,
            'consultingDirection': workHistory,
            'quotation': quotation,
            "phone": phone,

        }
    })
}
